import type { ChangeEvent, InputHTMLAttributes } from 'react';
import { createFieldErrorId } from '@gonfalon/legacy-forms/formUtils';
import cx from 'clsx';

import './styles/UploadLink.css';

type HTMLInputEvent = Event & {
  target: HTMLInputElement & EventTarget;
};

type UploadLinkProps = InputHTMLAttributes<HTMLInputElement> & {
  onChange: (file?: File | null) => void;
  id: string;
  maxSize: number;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  accept?: string;
};

export function UploadLink(props: UploadLinkProps) {
  const { id, className, children, disabled, accept, ...otherProps } = props;
  const classes = cx('UploadLink', className);

  const handleChange = (event?: ChangeEvent) => {
    const { maxSize, onChange } = props;

    let file;
    if (event) {
      const e = event as unknown as HTMLInputEvent;
      file = e.target.files?.[0];
    }

    if (file && file.size > maxSize) {
      return;
    }

    event?.persist();
    onChange(file);
  };

  return (
    <span className={classes}>
      <input
        className="UploadLink-input"
        id={id}
        aria-describedby={otherProps['aria-describedby'] || createFieldErrorId(id)}
        type="file"
        onChange={handleChange}
        disabled={disabled}
        accept={accept}
      />
      <label htmlFor={id} className="UploadLink-label">
        {children}
      </label>
    </span>
  );
}
